import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import DrawerComponentViewModel from "src/app/components/drawer/drawer.viewmodel";
import colorsConstants from "src/app/constants/colors.constants";
import DrawerModel, {
  DrawerOption,
} from "src/app/models/components/drawer.model";
import styles from "src/app/styles/components/drawer.component.style";
const DrawerComponentView: React.FC<DrawerModel> = (
  drawerProps: DrawerModel,
) => {
  const { selectedId } = drawerProps as {
    selectedId: string;
  };
  const {
    isDrawerOpen,
    toggleDrawer,
    isMobile,
    navigateToScreen,
    roleSpecificDrawerOptions,
    logout,
    separateSites,
    getPageVariation,
    switchBetweenSites,
  } = DrawerComponentViewModel(drawerProps);
  return (
    <Box>
      <Button onClick={toggleDrawer(true)} sx={styles.menuButton}>
        <MenuIcon sx={styles.menuIcon} />
      </Button>
      <Drawer
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        variant={isMobile ? "temporary" : "permanent"}
      >
        <Box
          sx={styles.drawerContainer}
          role="presentation"
          onClick={toggleDrawer(false)}
        >
          {getPageVariation() === "warpa" || !separateSites ? (
            <Button
              sx={styles.appInfoContainer}
              disabled={!separateSites}
              onClick={switchBetweenSites}
            >
              <Box
                component="img"
                src="/icons/warpa-1024x1024.png"
                sx={styles.drawerAppIcon}
              />
              <Typography sx={styles.appNameText}>W.A.R.P.A</Typography>
            </Button>
          ) : (
            <Button
              sx={styles.appInfoContainer}
              disabled={!separateSites}
              onClick={switchBetweenSites}
            >
              <Box
                component="img"
                src="/icons/pod-1024x1024.png"
                sx={styles.drawerAppIcon}
              />
              <Typography sx={styles.appNameText}>P.O.D</Typography>
            </Button>
          )}

          <List>
            {roleSpecificDrawerOptions.map((option: DrawerOption) => (
              <ListItem
                key={option.displayName}
                disablePadding
                sx={styles.ListItemContainer}
              >
                <ListItemButton
                  sx={
                    option.displayName === selectedId
                      ? styles.ListItemButtonContainerSelected
                      : styles.ListItemButtonContainer
                  }
                  onClick={() => navigateToScreen(option.navigationPath)}
                >
                  <option.icon
                    sx={
                      option.displayName === selectedId
                        ? styles.listItemIconSelected
                        : styles.listItemIcon
                    }
                  />
                  <ListItemText
                    primary={option.displayName}
                    sx={
                      option.displayName === selectedId
                        ? styles.listItemIconSelected
                        : styles.listItemIcon
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
            <ListItem
              key={"logout"}
              disablePadding
              sx={styles.ListItemContainer}
            >
              <ListItemButton
                sx={styles.ListItemButtonContainer}
                onClick={logout}
              >
                <LogoutIcon
                  sx={[styles.listItemIcon, { color: colorsConstants.error }]}
                />
                <ListItemText
                  primary={"Logout"}
                  sx={[styles.listItemIcon, { color: colorsConstants.error }]}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default DrawerComponentView;
